/**
 * LIVISIBLY DESIGN SYSTEM — JS TOKEN EXPORT
 *
 * JavaScript version of design tokens for use in:
 * - MUI theme configuration
 * - Inline styles where CSS vars aren't practical
 * - Dynamic styling logic
 *
 * These MUST stay in sync with the CSS token files.
 */

export const colors = {
  navy: {
    950: '#102a43',
    900: '#1B2F5E',
    800: '#243b53',
    700: '#334e68',
    600: '#486581',
    500: '#627d98',
    400: '#829ab1',
    300: '#9fb3c8',
    200: '#bcccdc',
    100: '#d9e2ec',
    50: '#f0f4f8',
  },
  accent: {
    900: '#164e63',
    800: '#155e75',
    700: '#0e7490',
    600: '#0891b2',
    500: '#14b8a6',
    400: '#2dd4bf',
    300: '#5eead4',
    200: '#99f6e4',
    100: '#ccfbf1',
    50: '#f0fdfa',
  },
  success: {
    700: '#15603b',
    600: '#16794a',
    500: '#1d9b5e',
    100: '#d1fae5',
    50: '#ecfdf5',
  },
  warning: {
    700: '#92400e',
    600: '#b45309',
    500: '#d97706',
    100: '#fef3c7',
    50: '#fffbeb',
  },
  error: {
    700: '#991b1b',
    600: '#b91c1c',
    500: '#dc2626',
    100: '#fee2e2',
    50: '#fef2f2',
  },
  info: {
    700: '#1d3faf',
    600: '#1e40af',
    500: '#3b82f6',
    100: '#dbeafe',
    50: '#eff6ff',
  },
  gray: {
    950: '#0c0c0e',
    900: '#18181b',
    800: '#27272a',
    700: '#3f3f46',
    600: '#52525b',
    500: '#71717a',
    400: '#a1a1aa',
    300: '#d4d4d8',
    200: '#e4e4e7',
    100: '#f0f0f2',
    50: '#f8f8fa',
  },
  white: '#ffffff',
};

export const typography = {
  fontFamily: {
    display: "'Source Serif 4', Georgia, 'Times New Roman', serif",
    body: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    mono: "'JetBrains Mono', 'Fira Code', Consolas, monospace",
  },
  fontSize: {
    xs: '0.75rem',
    sm: '0.8125rem',
    base: '0.9375rem',
    lg: '1.0625rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
  },
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
};

export const spacing = {
  navWidthCollapsed: 68,
  navWidthExpanded: 252,
  chatWidth: 380,
  headerHeight: 56,
};

export const shadows = {
  sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
  md: '0 2px 8px rgba(0, 0, 0, 0.08)',
  lg: '0 4px 16px rgba(0, 0, 0, 0.1)',
  xl: '0 8px 32px rgba(0, 0, 0, 0.12)',
};

export const radii = {
  sm: 6,
  md: 8,
  lg: 12,
  xl: 16,
  full: 9999,
};
